/* ============================================================
   AK26 Teaser-Page — Adventskalender 2026 Pre-Access
   Vanilla JS, keine Dependencies. Idempotent (mehrfaches Laden
   durch mehrere Sections ist unschädlich).
   ============================================================ */
(function () {
  'use strict';
  if (window.__akTeaserInit) return;
  window.__akTeaserInit = true;

  var LS_SIGNUP = 'ak26_signed_up';
  var KLAVIYO_REVISION = '2024-10-15';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Helpers ── */
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lsGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* Safari private mode */ } }
  function trackEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
  function isSignedUp() {
    return lsGet(LS_SIGNUP) === '1' || !!document.querySelector('.ak-signup.done');
  }

  /* ── Countdown ─────────────────────────────────────────────
     Ziel-Datum kommt als ISO-String mit Offset aus dem Section-
     Setting (z. B. 2026-08-23T00:00:00+02:00 = Europe/Berlin). */
  function initCountdowns() {
    var wraps = qsa('[data-ak-countdown]');
    if (!wraps.length) return;

    var items = wraps.map(function (wrap) {
      var target = Date.parse(wrap.getAttribute('data-target') || '');
      if (isNaN(target)) {
        wrap.style.display = 'none';
        return null;
      }
      return {
        wrap: wrap,
        target: target,
        d: wrap.querySelector('[data-ak-cd="d"]'),
        h: wrap.querySelector('[data-ak-cd="h"]'),
        m: wrap.querySelector('[data-ak-cd="m"]'),
        s: wrap.querySelector('[data-ak-cd="s"]'),
        live: false
      };
    }).filter(Boolean);
    if (!items.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = Date.now();
      items.forEach(function (it) {
        var diff = Math.max(0, it.target - now);
        if (diff === 0) {
          if (!it.live) {
            it.live = true;
            it.wrap.classList.add('ak-is-live');
            trackEvent({ event: 'ak26_countdown_live' });
          }
          return;
        }
        if (it.d) it.d.textContent = Math.floor(diff / 86400000);
        if (it.h) it.h.textContent = pad(Math.floor(diff / 3600000) % 24);
        if (it.m) it.m.textContent = pad(Math.floor(diff / 60000) % 60);
        if (it.s) it.s.textContent = pad(Math.floor(diff / 1000) % 60);
      });
    }
    tick();
    window.setInterval(tick, 1000);
  }

  /* ── Konfetti ──
     Ohne Argument: Emoji-Regen über die Seite (Signup-Success).
     Mit { burst: element }: kurzer Burst aus ~25 CSS-Partikeln in Markenfarben, der vom
     Element ausgeht (Set-CTA), 1 s, danach aus dem DOM. Beides aus bei reduced motion. */
  function confetti(opts) {
    if (reducedMotion) return;
    if (opts && opts.burst) {
      var origin = opts.burst;
      var host = origin.closest('.ak-set') || origin.parentNode;
      if (!host) return;
      var hostRect = host.getBoundingClientRect();
      var rect = origin.getBoundingClientRect();
      var x = rect.left - hostRect.left + rect.width / 2;
      var y = rect.top - hostRect.top + rect.height / 2;
      var colors = ['#ffd98a', '#e2004b', '#ffffff', '#c9a24b', '#f6dbe3'];
      for (var j = 0; j < 25; j++) {
        var p = document.createElement('i');
        p.className = 'ak-confetti-burst';
        p.style.background = colors[j % colors.length];
        p.style.left = x + 'px';
        p.style.top = y + 'px';
        p.style.setProperty('--dx', (Math.random() * 260 - 130) + 'px');
        p.style.setProperty('--dy', (Math.random() * -180 - 30) + 'px');
        p.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
        host.appendChild(p);
        window.setTimeout(function (node) { node.remove(); }.bind(null, p), 1100);
      }
      return;
    }
    var icons = ['🎉', '🎄', '✨', '🎁', '❄️'];
    for (var i = 0; i < 24; i++) {
      var el = document.createElement('div');
      el.className = 'ak-confetti';
      el.textContent = icons[i % icons.length];
      el.style.left = Math.random() * 100 + 'vw';
      el.style.animationDuration = (2.2 + Math.random() * 1.8) + 's';
      el.style.animationDelay = (Math.random() * 0.4) + 's';
      document.body.appendChild(el);
      window.setTimeout(function (node) { node.remove(); }.bind(null, el), 4500);
    }
  }

  /* ── Live-Counter +1 (kleiner Dopamin-Kick nach Anmeldung) ── */
  function bumpLeadCounter() {
    qsa('[data-ak-lead-count]').forEach(function (el) {
      var n = parseInt((el.textContent || '').replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) el.textContent = (n + 1).toLocaleString('de-DE');
    });
  }

  /* ── Signup: Success-State (gemeinsam für Embed + API-Fallback) ── */
  function markSignupSuccess(container, source) {
    container.classList.add('done');
    container.classList.remove('has-error');
    lsSet(LS_SIGNUP, '1');
    bumpLeadCounter();
    confetti();
    updateStickyBars();
    trackEvent({ event: 'ak26_signup', signup_source: source || 'teaser_page' });
    /* Profil-Property signup_source nachziehen (fürs Segment
       "Sign Ups in Awareness Phase"). Beim API-Fallback ist die
       Property bereits im Subscribe-Call enthalten — hier best effort
       fürs Embed-Formular, sobald Klaviyo das Profil identifiziert hat. */
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function' && source) {
        window.klaviyo.identify({ signup_source: source });
      }
    } catch (e) { /* Klaviyo (noch) nicht geladen — Property kommt dann nur über den API-Weg */ }
  }

  /* ── Klaviyo Embed-Formulare ─────────────────────────────────
     Das Embed rendert Klaviyo selbst (Onsite-JS der Klaviyo-App).
     Wir hören auf das submit-Event, um Success-State, Konfetti und
     Sticky-Bar zu steuern. */
  function initKlaviyoEmbedBridge() {
    window.addEventListener('klaviyoForms', function (e) {
      var detail = e.detail || {};
      if (detail.type !== 'submit') return;
      var containers = qsa('[data-ak-signup]');
      var match = null;
      if (detail.formId) {
        containers.some(function (c) {
          if (c.querySelector('[data-ak-embed-form="' + detail.formId + '"]')) { match = c; return true; }
          return false;
        });
      }
      if (!match) return; // Submit eines fremden Klaviyo-Popups ignorieren
      markSignupSuccess(match, match.getAttribute('data-source'));
    });
  }

  /* ── API-Fallback: Subscribe auf Listen-ID (Klaviyo Client API).
     Double-Opt-In bleibt aktiv — Klaviyo verschickt die DOI-Mail,
     sobald die Liste auf Double-Opt-In steht. ── */
  function getCompanyId(explicit) {
    if (explicit) return Promise.resolve(explicit);
    try {
      if (window.klaviyo && typeof window.klaviyo.account === 'function') {
        return window.klaviyo.account().then(function (id) { return id || null; });
      }
    } catch (e) { /* fall through */ }
    return Promise.resolve(null);
  }

  function subscribeViaApi(form, container) {
    var input = form.querySelector('input[type=email]');
    var button = form.querySelector('button[type=submit]');
    var email = input && input.value.trim();
    var listId = form.getAttribute('data-list-id');
    var source = container.getAttribute('data-source') || 'teaser_page';
    if (!email || !listId) { showFormError(container); return; }

    if (button) button.disabled = true;
    container.classList.remove('has-error');

    getCompanyId(form.getAttribute('data-company-id')).then(function (companyId) {
      if (!companyId) throw new Error('no klaviyo company id');
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { signup_source: source }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
      return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(payload)
      });
    }).then(function (res) {
      if (!res || !res.ok) throw new Error('klaviyo subscribe failed');
      markSignupSuccess(container, source);
    }).catch(function () {
      if (button) button.disabled = false;
      showFormError(container);
    });
  }

  function showFormError(container) {
    container.classList.add('has-error');
  }

  function initApiForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[data-ak-form]');
      if (!form) return;
      e.preventDefault();
      var container = form.closest('[data-ak-signup]');
      if (container) subscribeViaApi(form, container);
    });
  }

  /* ── Scroll zum ersten (noch offenen) Formular ── */
  function scrollToForm() {
    var target = document.querySelector('[data-ak-signup]:not(.done)') || document.querySelector('[data-ak-signup]');
    if (!target) return;
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    window.setTimeout(function () {
      var input = target.querySelector('input[type=email], input');
      if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
    }, 600);
  }

  function initScrollTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-ak-scroll-to-form]');
      if (!trigger) return;
      e.preventDefault();
      scrollToForm();
    });
  }

  /* ── Umfrage ── */
  function initPolls() {
    qsa('[data-ak-poll]').forEach(function (poll) {
      var storageKey = 'ak26_poll_' + (poll.getAttribute('data-poll-id') || 'default');

      function reveal(chosenLabel, animate) {
        poll.classList.add('voted');
        qsa('[data-ak-poll-btn]', poll).forEach(function (btn) {
          var pct = parseInt(btn.getAttribute('data-pct'), 10) || 0;
          var bar = btn.querySelector('.ak-bar');
          if (bar) {
            if (!animate) bar.style.transition = 'none';
            bar.style.width = pct + '%';
          }
          btn.disabled = true;
          if (chosenLabel && btn.getAttribute('data-label') === chosenLabel) {
            btn.classList.add('is-chosen');
          }
        });
      }

      var stored = lsGet(storageKey);
      if (stored) { reveal(stored, false); return; }

      poll.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-ak-poll-btn]');
        if (!btn || poll.classList.contains('voted')) return;
        var label = btn.getAttribute('data-label') || '';
        lsSet(storageKey, label);
        reveal(label, true);
        trackEvent({
          event: 'ak26_poll_vote',
          poll_option: label,
          poll_pct: parseInt(btn.getAttribute('data-pct'), 10) || 0
        });
      });
    });
  }

  /* ── Sticky-Bar: nach dem Hero einblenden, nie nach Anmeldung ── */
  var stickyBars = [];
  function updateStickyBars() {
    if (!stickyBars.length) return;
    /* Im Theme-Editor immer sichtbar, damit sie ohne Scrollen stylebar ist */
    if (window.Shopify && window.Shopify.designMode) {
      stickyBars.forEach(function (bar) { bar.classList.add('show'); });
      return;
    }
    var hero = document.querySelector('.ak-hero');
    var threshold = hero
      ? hero.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * 0.25
      : window.innerHeight * 0.9;
    var show = window.scrollY > threshold && !isSignedUp();
    stickyBars.forEach(function (bar) { bar.classList.toggle('show', show); });
  }

  function initStickyBars() {
    stickyBars = qsa('[data-ak-sticky]');
    if (!stickyBars.length) return;
    window.addEventListener('scroll', updateStickyBars, { passive: true });
    window.addEventListener('resize', updateStickyBars);
    updateStickyBars();
  }

  /* ── Warenkorb: EIN Helfer für Kauf-Karten, Set-Teaser und Beide-kaufen-Bar ──
     Das Theme (Palo Alto) hat keine wiederverwendbare Promise-API fürs Hinzufügen
     (CartDrawer.addToCart hängt am PDP-Formular). Genutzt wird deshalb die Theme-Infrastruktur:
     theme.routes.cart_add_url für den Request, window.cart.getCart() zum Rendern/Öffnen des
     Cart-Drawers inkl. Zähler (feuert theme:cart:added), sonst das Event als Fallback. */
  var ADDED_MS = 1600;

  function cartAdd(items) {
    var base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    return fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || (json && json.status)) throw json || {};
        return json;
      }, function () { if (!response.ok) throw {}; return {}; });
    });
  }

  function cartRefresh(openDrawer) {
    if (openDrawer && window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
  }

  function announce(scope, text) {
    var live = scope && scope.querySelector('[data-ak-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 30);
  }

  function errorMessage(err, fallback) {
    var m = err && (err.description || err.message);
    return (typeof m === 'string' && m) ? m : fallback;
  }

  /* Kauf-Karten + Set-CTA: echte Produkt-Formulare (No-JS: normaler Add), mit JS per AJAX */
  function initBuyForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-ak-atc-form]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-ak-atc]');
      if (!btn || btn.disabled || btn.dataset.state === 'loading') return;
      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : 0;
      var label = btn.querySelector('[data-ak-atc-label]');
      var idle = label ? label.textContent : '';
      var scope = btn.closest('.ak-section') || document;
      var body = btn.closest('.ak-mystery-body, .ak-set__body');
      var errEl = body ? body.querySelector('[data-ak-atc-error]') : null;
      if (!(variantId > 0)) { if (errEl) { errEl.textContent = btn.dataset.error || 'Fehler'; errEl.hidden = false; } return; }
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      btn.style.minWidth = btn.offsetWidth + 'px';
      btn.dataset.state = 'loading';
      cartAdd([{ id: variantId, quantity: 1 }])
        .then(function () {
          btn.dataset.state = 'success';
          if (label) label.textContent = btn.dataset.added || idle;
          announce(scope, (btn.dataset.title || '') + ' ' + (btn.dataset.added || ''));
          if (btn.hasAttribute('data-confetti')) confetti({ burst: btn });
          cartRefresh(btn.dataset.openDrawer !== 'false');
          window.setTimeout(function () {
            btn.dataset.state = 'idle';
            if (label) label.textContent = idle;
            btn.style.minWidth = '';
          }, ADDED_MS);
        })
        .catch(function (err) {
          var msg = errorMessage(err, btn.dataset.error || 'Fehler');
          btn.dataset.state = 'idle';
          btn.style.minWidth = '';
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
          announce(scope, msg);
        });
    });
  }

  /* Beide-kaufen-Bar (bestehendes Element): zwei Varianten-IDs, gleicher Helfer */
  function initBundleBar() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ak-bundle-atc]') : null;
      if (!btn || btn.disabled) return;
      var bar = btn.closest('.ak-bundlebar');
      var errEl = bar ? bar.querySelector('.ak-bundlebar__error') : null;
      var ids = [btn.dataset.variantA, btn.dataset.variantB]
        .map(function (v) { return parseInt(v, 10); })
        .filter(function (v) { return v > 0; });
      if (ids.length < 2) { if (errEl) errEl.hidden = false; return; }
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      if (errEl) errEl.hidden = true;
      cartAdd(ids.map(function (id) { return { id: id, quantity: 1 }; }))
        .then(function () {
          btn.textContent = btn.dataset.success || origText;
          btn.disabled = false;
          cartRefresh(true);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = origText;
          if (errEl) errEl.hidden = false;
        });
    });
  }

  /* Schneefall auf der Set-Bühne: 14 kleine ❄, langsam (Muster aus dem Wireframe); aus bei reduced motion */
  function initSetSnow() {
    qsa('[data-ak-snow]').forEach(function (set) {
      if (set.dataset.akSnowInit === 'true' || reducedMotion) return;
      set.dataset.akSnowInit = 'true';
      var layer = set.querySelector('.ak-set__snow');
      if (!layer) return;
      for (var i = 0; i < 14; i++) {
        var f = document.createElement('span');
        f.className = 'ak-set__flake';
        f.textContent = '❄';
        f.style.left = (i * 7.2 + 2) + '%';
        f.style.fontSize = (7 + (i % 3) * 4) + 'px';
        f.style.animationDuration = (5 + (i % 5) * 1.6) + 's';
        f.style.animationDelay = -((i * 1.3) % 8) + 's';
        layer.appendChild(f);
      }
    });
  }

  /* ── Init ── */
  function init() {
    initCountdowns();
    initKlaviyoEmbedBridge();
    initApiForms();
    initScrollTriggers();
    initPolls();
    initStickyBars();
    initBuyForms();
    initBundleBar();
    initSetSnow();
    document.addEventListener('shopify:section:load', initSetSnow); /* Theme-Editor: Section neu geladen */
    /* Bereits angemeldet (z. B. Reload): Formulare direkt im Success-State */
    if (lsGet(LS_SIGNUP) === '1') {
      qsa('[data-ak-signup]').forEach(function (c) { c.classList.add('done'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
